import {Component, forwardRef, Input} from '@angular/core';
import { FloatLabel } from 'primeng/floatlabel';
import {CommonModule} from '@angular/common';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from "@angular/forms";
import { Select, SelectModule } from 'primeng/select';

@Component({
  selector: 'shared-ui-cron-expression-dropdown',
  standalone: true,
  imports: [FloatLabel,
    CommonModule, SelectModule, FormsModule, Select],
  templateUrl: './cron-expression-dropdown.component.html',
  styleUrls: ['./cron-expression-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CronExpressionDropdownComponent),
      multi: true,
    }
  ],
})
export class CronExpressionDropdownComponent implements ControlValueAccessor {

  @Input() cronOptions = [];

  @Input() label = '';

  @Input() style: any | undefined = undefined;

  @Input() styleClass: any | undefined = undefined;

  @Input() showClear = false;

  @Input() required = false;

  selectedCron: string | null = null;

  _onChange: ((value: string) => void) | null = null
  _onTouched: (() => void) | null = null

  writeValue(value: string): void {
    this.selectedCron = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  onChange(value: any) {
    if(this._onChange) {
      this._onChange(value);
    }
  }
}
